export default "__VITE_ASSET__qBkHPNoJ__"